<template>
  <v-card class="pa-5 ml-10 mr-10 mt-5">
    <v-card-title>Module</v-card-title>
    <v-card-text>
      <v-data-table
        hide-default-footer
        items-per-page="20"
        class="border-table"
        density="compact"
        :headers="headers"
        hide-no-data
        item-value="id"
        :items="items">
        <template v-slot:item.active="{ item }">
          <v-checkbox
            :data-cy="'module-' + item.id + '-active'"
            :true-value="1"
            :false-value="0"
            :model-value="item.slots"
            @update:model-value="($event) => changeValue(item.value, $event)"
            hide-details>
          </v-checkbox>
          <span v-if="item.monthEnd">(Noch bis zum Ende des Monats)</span>
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-text>
      <v-row class="mt-5">
        <v-col
          cols="6"
          style="display: grid; justify-content: end"
          >Monatliche Kosten</v-col
        >
        <v-col
          cols="6"
          style="display: grid; justify-content: end">
          <s
            data-cy="old-monthly-costs"
            v-if="oldMonthlyCost !== 0 && oldMonthlyCost !== monthlyCost"
            >{{ oldMonthlyCost }} €</s
          >
          <span data-cy="final-monthly-costs">{{ monthlyCost }} €</span>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn @click="router.back()"> Zurück </v-btn>
      <v-btn
        :readonly="saving"
        @click="saveModules(() => save())">
        <template v-if="saving">
          <v-progress-circular indeterminate />
        </template>
        <template v-else>Speichern</template>
      </v-btn>
    </v-card-actions>
  </v-card>
  <v-dialog
    v-model="dialog.open"
    persistent>
    <LicenceReviewPopup
      private
      @close="dialog.open = false"
      @save="submit"
      :monthly-costs="monthlyCost"
      :yearly-costs="0"
      :additional-costs="additionalPrice"
      :remaining-days="remainingDays"
      :initial-items="initialItems"
      :items="items"
      :charge-needed="chargeNeeded"
      :modules-removed="modulesRemoved" />
  </v-dialog>
</template>

<script lang="ts" setup>
import { useConfirm, useSnackbar } from "vuetify-use-dialog";
import { ref, toRef } from "vue";
import { useTranslation } from "i18next-vue";
import { useMainStore } from "@/stores/mainStore";
import { useModules } from "./moduleComposable";
import LicenceReviewPopup from "@/components/dialogs/LicenceReviewPopup.vue";
import { c } from "vite/dist/node/types.d-aGj9QkWt";
import { useRouter } from "vue-router";

const createConfirm = useConfirm();
const createSnackbar = useSnackbar();
const { t } = useTranslation();
const mainStore = useMainStore();

const dialog = ref({
  open: false,
  onSuccess: () => {}
});

const emit = defineEmits(["moduleUpdate"]);
const props = defineProps({
  slots: Object,
  allSlots: Object,
  save: Function,
  saving: Boolean,
  current_status: String,
  licenceId: Number
});

const model = defineModel();

defineExpose({
  saveModules
});

const {
  headers,
  items,
  oldMonthlyCost,
  monthlyCost,
  modulesRemoved,
  remainingDays,
  chargeNeeded,
  initialItems,
  loadPreview,
  changeNeeded,
  additionalPrice
} = useModules(
  true,
  toRef(() => model.value),
  toRef(() => props.allSlots),
  toRef(() => props.current_status),
  toRef(() => props.licenceId)
);

function changeValue(item: number, value: number) {
  console.log(value);
  model.value[item] = value;
}

const router = useRouter();

function saveModules(callback: () => void) {
  if (!changeNeeded.value) {
    router.back();
    return;
  }
  dialog.value.onSuccess = callback;
  dialog.value.open = true;
  chargeNeeded.value > 0 && loadPreview();
}

function submit() {
  dialog.value.onSuccess();
}
</script>
